import { Link } from "react-router-dom";

interface Props {
  eyebrow: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({ eyebrow, title, desc, moreTo, moreLabel }: Props) {
  return (
    <div className="mb-7 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-800">
          <i className="ri-bubble-chart-line" aria-hidden="true" />
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl md:text-3xl text-foreground-950">{title}</h2>
        {desc && <p className="mt-2 max-w-2xl text-sm text-foreground-600">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800"
        >
          {moreLabel ?? "查看全部"}
          <i className="ri-arrow-right-line" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}